import { lazy } from './lazy.js'
import { initNewsSlider } from '../../../components/news_slider/index'
import { initPhotoCarousel } from '../../../components/photo_carousel/index'
import { initTextVisualsTabs } from '../../../components/text_visuals_tabs/index'
import { initGlobeHeader } from '../../../components/globe_header/index'
import { initContentScrollTo } from '../../../components/content_with_scrollto/index'
import { initContactForm } from '../../../components/contact_form/index'
import { initTeamGrid } from '../../../components/team_grid/index'
import { initVideo } from '../../../components/video/index'
import { initManifest } from '../../../components/manifest/index'
import { initMetrics } from '../../../components/numbers_block/index'
import { initDigIn } from '../../../components/dig_in_blocks/index'
import { BlockLinks } from '../../../components/block_links/index'
import { initBusinessHeader } from '../../../components/business_header/index'
import { initNewsletter } from '../../../templates/parts/newsletter/index'
import { ProjectCells } from '../../../templates/parts/project-cell'
import { Tiles } from '../../../templates/parts/tile'
import { initInputs } from '../parts/input'
import { Lottie } from '../parts/lottie'
import { Parallax } from '../parts/parallax'
import { InViews } from '../parts/in-view'
import { Buttons } from '../parts/buttons'
import '../../../components/donate/index' // Uses alpinejs. Please do not remove
import { dl } from './app.js'
import { DonateDL } from '../../../components/donate/index'
import { initAccordion } from '../../../templates/parts/accordion-items'
import { BeforeAfterSliders } from '../parts/before-after-slider.js'
import { BeforeAfterHeader } from '../../../components/before_after_header/index.js'
import { InteractiveMap } from '../../../components/interactive_map/index.js'
import { NumbersBlockProgress } from '../../../components/numbers_block_progress/index.js'

export let parallax

export const initPage = () => {
  if (lazy) { lazy.update() }
  dl.pageView()
  document.body.style.overflow = 'unset'
  initNewsSlider()
  initPhotoCarousel()
  initTextVisualsTabs()
  initGlobeHeader()
  initContentScrollTo()
  initAccordion()
  initVideo()
  initManifest()
  initMetrics()
  initLangSwitches()
  initNewsletter()
  initInputs()
  initContactForm()
  initTeamGrid()
  initBusinessHeader()
  initDigIn()
  new InViews()
  new Lottie()
  new Buttons()
  new ProjectCells()
  new Tiles()
  new BlockLinks()
  new DonateDL()
  new BeforeAfterSliders()
  new BeforeAfterHeader()
  new InteractiveMap()
  new NumbersBlockProgress()
}

const initLangSwitches = () => {
  const selects = [...document.querySelectorAll('.language_switch')]

  for (let i = selects.length - 1; i >= 0; i--) {
    const select = selects[i]
    selects[i].addEventListener('change', e => {
      const value = select.options[select.selectedIndex].value
      window.location = value
    })
  }
}
